import { EProductStatus, EProductType } from 'models/product'
import { ESellerStatus } from 'models/seller'
import { ISellerDisableState, isSellerHidden } from 'shared/utils/sellerDisableReasons'

interface ISiteCardState {
  slug?: string
  photo?: string[]
  status?: EProductStatus
  type?: EProductType
  parentStatus?: EProductStatus
  seller?: ISellerDisableState & { status?: string }
}

const PUBLIC_STATUSES = [EProductStatus.PUBLISHED, EProductStatus.DISABLED]

// Те же условия, при которых витрина отдаёт карточку, а не 404
// (бэкенд: ProductService.getWithReviewsData). null — карточка открывается
export const getSiteUnavailableReason = ({
  slug,
  photo,
  status,
  type,
  parentStatus,
  seller
}: ISiteCardState): string | null => {
  if (!slug) {
    return 'Товар ещё не сохранён'
  }
  if (!status || !PUBLIC_STATUSES.includes(status)) {
    return 'На сайте видны только опубликованные и отключённые товары'
  }
  if (!photo?.[0]) {
    return 'Товар без фото на сайте не показывается'
  }
  if (!seller || isSellerHidden(seller) || seller.status !== ESellerStatus.APPROVED) {
    return 'Магазин продавца скрыт или не одобрен'
  }
  if (
    type === EProductType.VARIATION &&
    parentStatus &&
    !PUBLIC_STATUSES.includes(parentStatus)
  ) {
    return 'Основной товар не опубликован'
  }
  return null
}
